export default __webpack_public_path__ + "static/media/skovstykket-townhouse-4-rooms-13.48d4155f.jpg";